import {
  styled,
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  IconButton as MuiIconButton,
  dialogTitleClasses,
  dialogContentClasses,
} from "@mui/material";

export const Dialog = styled(MuiDialog)`
  &.not-border-bottom {
    .${dialogTitleClasses.root} {
      border-bottom: none;
    }
  }
`;

export const DialogTitle = styled(MuiDialogTitle)`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  border-bottom: 1px solid #dee2ec;
  padding: 16px;
`;

export const DialogContent = styled(MuiDialogContent)`
  &.${dialogContentClasses.root} {
    padding: 16px;
    font-size: 14px;
  }
`;

export const DialogActions = styled(MuiDialogActions)`
  padding: 16px;
`;

export const IconButton = styled(MuiIconButton)`
  margin-left: auto;
  svg {
    width: 10px;
    height: 10px;
  }
`;
